import { render, staticRenderFns } from "./CompanyCard.vue?vue&type=template&id=0816c478&"
import script from "./CompanyCard.vue?vue&type=script&lang=js&"
export * from "./CompanyCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports